<template>
    <div style="display:inline-flex">
        <a-range-picker ref="cTimeRange"
            :show-time="{
                        format:'HH'
                    }" 
            :format="dateFormat"
            v-model="timeRange"
            @change="onChange" />

        <a-select v-model="timeCurrent" style="width: 120px;margin-left:20px;" @change="handleTypeChange">
            <a-select-option v-for="item in timeValue" :key="item.key" :value="item.key">
                {{item.name}}
            </a-select-option>
        </a-select>
    </div>

</template>

<script>
import moment from 'moment';

export default {
    model:{
        prop:'selectedTimeRange',
        event:'change'
    },
    props:{
        selectedTimeRange:String
    },
    data() {
        return {
            dateFormat:"YYYY-MM-DD HH",
            tempDateFormat:"yyyy-MM-dd hh",
            timeRange:undefined,
            timeValue:[
                {
                    key:'02',
                    name:'按天查询'
                },
                {
                    key: '03',
                    name:'按小时查询'
                },
            ],

            timeCurrent:'03'
        }
    },
    methods: {
        onChange(){
            this.handleTimeChange();
        },
        //时间类型变动
        handleTypeChange(v){
            if(v == '02'){
                this.dateFormat = "YYYY-MM-DD"
                this.tempDateFormat = "yyyy-MM-dd"
            }
            else if(v == '03'){
                this.dateFormat = "YYYY-MM-DD HH"
                this.tempDateFormat = "yyyy-MM-dd hh"
            }
            this.handleTimeChange();
        },
        handleTimeChange(){
            //校验时间范围
            //判断时间范围，按天，跨度不能超 7 填，按小时，跨度不能超24小时
            let starttime =  new Date(this.timeRange[0]).getTime();
            let endtime = new Date(this.timeRange[1]).getTime();
            let timeDiff = endtime - starttime;
            if(this.timeCurrent == '02' && timeDiff > (7*24*60*60*1000)){
                this.message.error('按天查询，时间范围不能超7天')
                starttime = endtime - (24*60*60*1000*7);
            }
            if(this.timeCurrent == '03' && timeDiff > (24*60*60*1000)){
                this.message.error('按小时查询，时间范围不能超24小时')
                starttime = endtime - (24*60*60*1000);
            }
            starttime = new Date(starttime).Format("yyyy-MM-dd hh:mm");
            endtime = new Date(endtime).Format("yyyy-MM-dd hh:mm");
            this.timeRange = [moment(starttime, this.dateFormat), moment(endtime, this.dateFormat)];
            let t_start = new Date(this.timeRange[0]).Format(this.tempDateFormat);
            let t_end = new Date(this.timeRange[1]).Format(this.tempDateFormat);
            this.$emit("change",t_start + "~" + t_end + "~" + this.timeCurrent)
        },
   
    },
    mounted() {
        let now = new Date();
        let sTime = new Date(new Date(now).getTime() - (7*60*60*1000) ).Format("yyyy-MM-dd hh:mm");
        let eTime = now.Format("yyyy-MM-dd hh:mm");
        this.timeRange = [moment(sTime, this.dateFormat), moment(eTime, this.dateFormat)];
        this.handleTimeChange()
    },
    

}
</script>

<style scoped>
    .active{
        color: #fff;
        background-color: #1890ff;
        border-color: #1890ff;
        text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
        -webkit-box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
        box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
    }
</style>
